export default {
  created() {
    this.$store.dispatch('search/setContext', mz.context, { root: true })
  }
}
